'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import { Sphere, Line, Text } from '@react-three/drei';
import * as THREE from 'three';
import { ProjectBlueprint } from '@/data/projects';
interface BlueprintSchemaProps {
  blueprint: ProjectBlueprint;
}
export default function BlueprintSchema(t0) {
  const $ = _c(15);
  const {
    blueprint
  } = t0;
  const groupRef = useRef(null);
  let arr;
  if ($[0] !== blueprint.nodes) {
    arr = [];
    for (let i = 0; i < blueprint.nodes; i++) {
      const angle = i / blueprint.nodes * Math.PI * 2;
      const x = Math.cos(angle) * 10;
      const y = Math.sin(angle) * 10;
      const z = (Math.random() - 0.5) * 5;
      arr.push(new THREE.Vector3(x, y, z));
    }
    $[0] = blueprint.nodes;
    $[1] = arr;
  } else {
    arr = $[1];
  }
  const nodes = arr;
  let arr_0;
  if ($[2] !== nodes) {
    arr_0 = [];
    for (let i_0 = 0; i_0 < nodes.length; i_0++) {
      arr_0.push([nodes[i_0], nodes[(i_0 + 1) % nodes.length]]);
      if (Math.random() > 0.5) {
        const target = Math.floor(Math.random() * nodes.length);
        if (target !== i_0) {
          arr_0.push([nodes[i_0], nodes[target]]);
        }
      }
    }
    $[2] = nodes;
    $[3] = arr_0;
  } else {
    arr_0 = $[3];
  }
  const connections = arr_0;
  let t1;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = state => {
      if (!groupRef.current) {
        return;
      }
      groupRef.current.rotation.y = state.clock.getElapsedTime() * 0.1;
      groupRef.current.rotation.x = Math.sin(state.clock.getElapsedTime() * 0.2) * 0.1;
    };
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useFrame(t1);
  let t2;
  if ($[5] !== blueprint.type) {
    t2 = blueprint.type === "hub-and-spoke" && <Sphere args={[1.5, 32, 32]} position={[0, 0, 0]}><meshStandardMaterial color="#14b8a6" wireframe={true} emissive="#14b8a6" emissiveIntensity={2} /></Sphere>;
    $[5] = blueprint.type;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== nodes) {
    t3 = nodes.map(_temp);
    $[7] = nodes;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== connections) {
    t4 = connections.map(_temp2);
    $[9] = connections;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <group ref={groupRef}>{t2}{t3}{t4}</group>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp2(t0, i_2) {
  const [start, end] = t0;
  return <Line key={i_2} points={[start, end]} color="#14b8a6" lineWidth={1} transparent={true} opacity={0.3} />;
}
function _temp(pos, i_1) {
  return <group key={i_1} position={pos}><Sphere args={[0.3, 16, 16]}><meshStandardMaterial color="#14b8a6" wireframe={true} emissive="#14b8a6" emissiveIntensity={1} /></Sphere><Text position={[0, 0.6, 0]} fontSize={0.2} color="#14b8a6" font="https://fonts.gstatic.com/s/jetbrainsmono/v24/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8L6tjPQ.ttf">{`NODE_${i_1.toString().padStart(2, "0")}`}</Text></group>;
}